import { SalarySelectedDateOptionType } from "@/enums/enums";
import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class DashBoardService {
  DoGetSalarySummary(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        salarySummaryType: input.salarySummaryType,
        year: input.year,
      },
    };
    return service.peakPayrollAPI.post("/api/Salary/GetSalarySummary", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetChartDepartment(selectedDateOptionType: SalarySelectedDateOptionType) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        selectedDateOptionType: selectedDateOptionType,
      },
    };
    return service.peakPayrollAPI.post("/api/Salary/GetChartDepartment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetChartPosition(selectedDateOptionType: SalarySelectedDateOptionType) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        selectedDateOptionType: selectedDateOptionType,
      },
    };
    return service.peakPayrollAPI.post("/api/Salary/GetChartPosition", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetChartRevenueDeduct(selectedDateOptionType: SalarySelectedDateOptionType) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        selectedDateOptionType: selectedDateOptionType,
      },
    };
    return service.peakPayrollAPI.post("/api/Salary/GetChartRevenueDeduct", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetChartAccount(selectedDateOptionType: SalarySelectedDateOptionType) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        selectedDateOptionType: selectedDateOptionType,
      },
    };
    return service.peakPayrollAPI.post("/api/Salary/GetChartAccount", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateIntroduce() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakPayrollAPI.post("/api/User/UpdateIsRecommend", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetIntroduce() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakPayrollAPI.post("/api/User/GetRecommend", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new DashBoardService();
